var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"hardware",attrs:{"header-text":_vm.$t('tasks.listEquip'),"hide-footer":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('scrollable-container',{class:_vm.$style.scrollableContainer},_vm._l((Object.entries(_vm.data)),function(ref){
var key = ref[0];
var value = ref[1];
return _c('hardware-category',{key:key,attrs:{"name":key,"list":value}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }